<template>
  <div>

    <Spinner v-if="loading === true" />

    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button" />
    </div>
    <component is="b-card">
      <b-tabs
        v-if="true"
        pills
      >
        <!-- Tab: Account -->
        <b-tab
          active
          @click="catchTab('concept_autocad')"
        >
          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Phase 1</span>
          </template>
          <div class="mt-2 pt-75">
            <PhaseOne
              :tab="currentTab"
              :phase="projectPhases[0]"
              :parent-obj="phase1"
              @refreshPanel="getProject"
            />
          </div>
        </b-tab>

        <!-- Tab: Design Types -->
        <!--        <b-tab @click="catchTab('3D_images')">-->
        <!--        <b-tab @click="catchTab('3D_images')" :disabled="phase1 && phase1.completionForm">-->
        <b-tab
          :disabled="phase2Bool"
          @click="catchTab('3D_images')"
        >

          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Phase 2</span>
          </template>
          <div class="mt-2 pt-75">
            <PhaseTwo
              :tab="currentTab"
              :phase="projectPhases[1]"
              :parent-obj2="phase2"
              @refreshPanel="getProject"
            />
          </div>
        </b-tab>

        <!-- Tab: Stages & Phases -->
        <b-tab
          :disabled="phase3Bool"
          @click="catchTab('full_cad_package')"
        >
          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Phase 3</span>
          </template>
          <div class="mt-2 pt-75">
            <PhaseThree
              :tab="currentTab"
              :phase="projectPhases[2]"
              :parent-obj3="phase3"
              @refreshPanel="getProject"
            />
          </div>
        </b-tab>
        <b-tab
          :disabled="phase4Bool"
          @click="catchTab('poq')"
        >
          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Phase 4</span>
          </template>
          <div class="mt-2 pt-75">
            <PhaseFour
              :tab="currentTab"
              :phase="projectPhases[3]"
              :parent-obj4="phase4"
              @refreshPanel="getProject"
            />
          </div>
        </b-tab>
        <b-tab
          :disabled="phase5Bool"
          @click="catchTab('supervision')"
        >
          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Phase 5</span>
          </template>
          <div class="mt-2 pt-75">
            <PhaseFive
              :tab="currentTab"
              :phase="projectPhases[4]"
              :parent-obj5="phase5"
              @refreshPanel="getProject"
            />
          </div>
        </b-tab>
      </b-tabs>
    </component>
  </div>
</template>

<script>
import {
  BTab, BTabs, BCard,
} from 'bootstrap-vue'
import PhaseOne from './phaseOne/index.vue'
import PhaseTwo from './phaseTwo/index.vue'
import PhaseThree from './phaseThree/index.vue'
import PhaseFour from './phaseFour/index.vue'
import PhaseFive from './phaseFive/index.vue'
import Spinner from '@/shared/loader/Spinner'
import projectService from '@/services/projectService'

export default {
  components: {
    Spinner,
    BTab,
    BTabs,
    BCard,
    PhaseOne,
    PhaseTwo,
    PhaseThree,
    PhaseFour,
    PhaseFive,
  },
  data() {
    return {
      customRules: 'required',
      loading: false,
      projectPhases: [],
      currentTab: 'general_settings',
      phase1: '',
      phase2: '',
      phase3: '',
      phase4: '',
      phase5: '',
      phase2Bool: true,
      phase3Bool: true,
      phase4Bool: true,
      phase5Bool: true,

    }
  },
  mounted() {
    this.getProject()
  },
  methods: {
    catchTab(tab) {
      this.currentTab = tab
    },
    getProject() {
      projectService.project(this.$route.params.id).then(response => {
        console.log('llll', response.data.data)
        this.phase1 = response.data.data.phase1
        this.phase2 = response.data.data.phase2
        this.phase3 = response.data.data.phase3
        this.phase4 = response.data.data.phase4
        this.phase5 = response.data.data.phase5
        this.checkStages()
        this.projectPhases = response.data.data.phaseNames
      })
    },
    checkStages() {
      if (this.phase1 && this.phase1.completionForm) {
        this.phase2Bool = false
      }
      if (this.phase2 && this.phase2.completionForm) {
        this.phase3Bool = false
      }
      if (this.phase3 && this.phase3.completionForm) {
        this.phase4Bool = false
      }
      if (this.phase4 && this.phase4.completionForm) {
        this.phase5Bool = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
.forbidd-stage{
  cursor: not-allowed!important;
  pointer-events: none!important;

}
</style>
<style>
.forbidd-stage{
  cursor: not-allowed!important;
  pointer-events: none!important;

}
</style>
